import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/storage-hub/capture-storage/blob/$id")({
  staticData: {
    title: "common.blob",
  },
});
